// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-table-with-bars';

export const Component = () => (
  <>
    <path d='M10 6h12v3H10zm0 6h12v3H10zm0 6h12v3H10z' />
    <path d='M1 2v21h23V2H1Zm1 3h6v5H2V5Zm0 6h6v5H2v-5Zm0 6h6v5H2v-5Zm21 5H9v-5h14v5Zm0-6H9v-5h14v5Zm-2-6H9V5h14v5Z' />
  </>
);

export const viewBox = '0 0 25 25';
